exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PieChart__ChartAndDetail___2I4qY {\n}\n\n.PieChart__Chart___1rcAr,\n.PieChart__Detail___n71oW {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.PieChart__Chart___1rcAr {\n  display: flex;\n}\n\n.PieChart__Donut___2Gb1p {\n  flex: 1;\n  height: 100%;\n}\n\n.PieChart__Detail___n71oW {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.PieChart__Value___2tU5X {\n  color: #4c5773;\n  font-size: 22px;\n  font-weight: bolder;\n}\n\n.PieChart__Title___-GCLu {\n  color: #b8bbc3;\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.PieChart__Donut___2Gb1p path {\n  transition: opacity 0.3s linear;\n}\n", ""]);

// exports
exports.locals = {
	"ChartAndDetail": "PieChart__ChartAndDetail___2I4qY",
	"Chart": "PieChart__Chart___1rcAr",
	"Detail": "PieChart__Detail___n71oW",
	"Donut": "PieChart__Donut___2Gb1p",
	"Value": "PieChart__Value___2tU5X",
	"Title": "PieChart__Title___-GCLu"
};